<template>
  <div class="loading_wrap">
    <div class="svg_in rotateIn">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 100 100" fill="none">
        <path d="M46.3,0.2c-0.2,0-1.3,0.2-2.6,0.3l-2.3,0.3l0.1,0.8c0.1,0.4,0.2,0.9,0.2,1.1c0.1,0.2-0.1,0.4-0.5,0.4
          c-0.7,0.2-0.9,0-1.1-1.2C40.1,1.4,40,1,39.9,1C39.3,1,32.6,3,32,3.3c-0.1,0.1,0.1,0.5,0.3,1.1c0.4,1,0.4,1.2-0.4,1.4
          c-0.4,0.1-0.5,0-0.9-0.9c-0.3-0.9-0.4-1-0.8-0.9c-0.6,0.2-4.5,2.2-6,3l-1.3,0.8l0.6,0.8c0.3,0.5,0.6,0.9,0.6,1
          c0,0.1-0.3,0.3-0.5,0.5L23,10.6l-0.5-0.9c-0.3-0.5-0.6-0.9-0.8-0.9c-0.3,0-3.6,2.5-5.2,4l-1.4,1.3l0.7,0.8c0.6,0.6,0.7,0.8,0.5,1.1
          c-0.5,0.8-0.8,0.8-1.6,0L14,15.2l-1,1.1c-1.3,1.5-2,2.2-3,3.6L9,21.1l0.9,0.6c0.5,0.3,0.9,0.7,0.9,0.8s-0.2,0.3-0.4,0.6l-0.4,0.5
          l-0.9-0.6l-0.9-0.6l-0.6,0.8c-0.7,1-2.3,4-3,5.5l-0.5,1.1l1,0.4c0.9,0.4,1,0.4,0.9,0.9c-0.2,0.8-0.4,0.8-1.3,0.4
          c-0.5-0.2-1-0.3-1.1-0.2c-0.3,0.3-1.5,4-2.1,6.1c-0.5,2.1-0.5,2,0.9,2.3c0.8,0.1,0.9,0.1,0.7,0.7C3.1,40.6,3,40.9,2.9,41
          c0,0.1-0.5,0-1.1-0.1c-0.6-0.1-1.1-0.2-1.1-0.2c-0.1,0.1-0.7,4.7-0.8,6.4l-0.1,2.1L1,49.3l1.2,0.1V50v0.7L1,50.7l-1.2,0.1l0.1,2
          c0.2,3,0.5,5.4,0.8,5.5c0.1,0,0.6,0,1.2-0.1c0.9-0.2,0.9-0.1,1,0.3c0.2,0.8,0,1-1.1,1.2c-0.5,0.1-1,0.2-1,0.3c0,0.6,1.9,7.3,2.3,7.9
          c0,0.1,0.5,0,1.1-0.3c1.1-0.4,1.2-0.4,1.4,0.4c0.1,0.5,0.1,0.5-0.9,0.9c-0.9,0.3-1,0.4-0.9,0.7c0.2,0.6,2.2,4.6,3.1,6l0.8,1.3
          l0.5-0.3C8.5,76.4,9,76.2,9.2,76c0.5-0.4,0.5-0.3,0.9,0.3l0.3,0.6l-0.9,0.6c-0.5,0.3-0.9,0.6-0.9,0.7c0,0.4,4.8,6.4,5.3,6.6
          c0.1,0,0.5-0.3,1-0.7l0.8-0.7l0.5,0.5l0.5,0.5L15.9,85l-0.8,0.8l1.1,1c2,1.8,4.8,4.1,4.9,3.9c0-0.1,1.1-1.6,1.2-1.7
          c0.1-0.1,1.1,0.6,1.1,0.8c0,0.1-0.2,0.5-0.5,0.8c-0.3,0.4-0.5,0.7-0.5,0.9c0,0.2,1.5,1.1,4.1,2.6c0.5,0.3,1.4,0.7,2,1l1.1,0.5l0.4-1
          c0.4-0.9,0.5-1,0.9-0.9c0.8,0.2,0.8,0.4,0.4,1.4c-0.2,0.5-0.4,1-0.3,1.1c0.5,0.4,7.7,2.6,8.1,2.4c0.1-0.1,0.2-0.5,0.3-1.1
          c0.1-1,0.1-1,0.7-0.9c0.3,0.1,0.6,0.2,0.7,0.2c0.1,0.1,0,0.5-0.1,1.1c-0.1,0.5-0.2,1-0.1,1.1c0.3,0.2,4.3,0.7,6.4,0.8l2.2,0.1v-1.2
          c0-1,0-1.2,0.4-1.2c0.8,0,1,0.2,1,1.3v1.1l2-0.1c3.3-0.2,5.4-0.5,5.5-0.8c0.1-0.1,0-0.6-0.1-1.1c-0.2-0.8-0.2-0.9,0.2-1
          c0.9-0.3,1-0.2,1.2,1c0.1,0.6,0.2,1.1,0.3,1.1c0.8,0,7.6-2,7.9-2.3c0.1-0.1,0-0.6-0.3-1.1c-0.2-0.5-0.4-1-0.4-1
          c0.2-0.2,0.9-0.5,1.1-0.5c0.1,0,0.4,0.4,0.5,1c0.3,0.8,0.4,1,0.7,0.9c0.6-0.2,4.6-2.2,6-3.1c1.5-0.9,1.4-0.6,0.4-2.2
          c-0.3-0.4-0.3-0.5,0.3-0.9l0.6-0.4l0.6,0.9c0.3,0.5,0.6,0.9,0.6,0.9c0.1,0,6.1-4.8,6.5-5.3c0.1-0.1-0.1-0.5-0.6-1
          c-0.7-0.8-0.7-0.8-0.4-1.2c0.5-0.5,0.6-0.5,1.5,0.3l0.7,0.7l1.2-1.2c0.6-0.7,1.8-2,2.5-3c1.1-1.3,1.3-1.7,1.1-1.9
          c-0.2-0.1-0.6-0.4-0.9-0.6c-0.7-0.5-0.7-0.4-0.3-1.1c0.4-0.6,0.5-0.6,1.3,0c0.4,0.3,0.7,0.5,0.9,0.5c0.3,0,2.3-3.4,3.7-6.3l0.4-0.9
          l-0.9-0.4c-0.5-0.2-1-0.4-1-0.5c-0.1-0.1,0.4-1.2,0.5-1.2c0,0,0.5,0.2,1,0.4c0.5,0.2,1,0.3,1.1,0.3c0.3-0.3,1.6-4.2,2.1-6.1
          c0.5-2.1,0.5-2-0.8-2.3c-0.9-0.1-0.9-0.1-0.7-0.7c0.1-0.4,0.2-0.7,0.2-0.7c0,0,0.5,0,1.1,0.1c0.5,0.1,1,0.1,1.1,0.1
          c0.2-0.3,0.7-4.3,0.8-6.4l0.1-2.2h-1.1h-1.1v-0.7v-0.7h1.1h1.1L99.7,47c-0.1-1.2-0.2-2.9-0.4-3.7c-0.2-1.7-0.3-1.7-1.8-1.4
          c-0.6,0.1-0.6,0.1-0.7-0.5c-0.2-0.8-0.1-0.9,1.1-1c0.5-0.1,1-0.2,1-0.2c0-0.6-1.9-7.4-2.3-7.9c0-0.1-0.5,0-1.1,0.3
          c-0.5,0.2-1,0.4-1,0.3c-0.2-0.2-0.5-0.9-0.5-1.1c0-0.1,0.4-0.4,1-0.5c0.5-0.2,1-0.4,1-0.5c0-0.3-2.3-4.8-3.2-6.2l-0.8-1.3l-0.7,0.4
          c-0.4,0.2-0.8,0.5-1,0.6c-0.1,0.1-0.4-0.1-0.6-0.4l-0.4-0.6l0.9-0.5c0.5-0.3,0.9-0.6,0.9-0.7c0-0.4-2.7-3.8-4.4-5.7l-0.9-1L84.9,16
          c-0.6,0.6-0.8,0.7-1.1,0.5c-0.8-0.5-0.8-0.8,0-1.6l0.8-0.8l-1.1-1c-1.5-1.3-2.2-2-3.6-3l-1.2-0.9l-0.6,0.9c-0.3,0.5-0.7,0.9-0.7,0.9
          c-0.1,0-0.3-0.2-0.6-0.4l-0.5-0.4l0.6-0.9l0.6-0.9l-0.8-0.5c-1.1-0.8-4.2-2.5-5.5-3.1l-1.1-0.5l-0.4,1c-0.2,0.5-0.5,1-0.6,1
          C69,6.3,68.2,6,68,5.8c0,0,0.1-0.4,0.4-1c0.2-0.5,0.3-1,0.2-1.1c-0.3-0.3-4-1.5-6.1-2.1c-2.1-0.5-2-0.5-2.3,0.9
          c-0.1,0.8-0.1,0.9-0.7,0.7c-0.3-0.1-0.6-0.2-0.7-0.2c0-0.1,0-0.5,0.1-1.1c0.1-0.5,0.2-1,0.2-1.1c-0.2-0.1-4.6-0.7-6.4-0.8L50.6,0
          v1.1v1.1h-0.8h-0.8V1.1V0.1l-1.2,0C47.2,0.1,46.5,0.1,46.3,0.2z M55,19.6c12.4,2.1,22.4,11.7,25.1,24.2c0.3,1.3,0.4,2.9,0.5,5.4
          c0.1,4.2-0.3,7-1.5,10.6c-1.6,4.8-3.8,8.3-7.5,12c-4.5,4.5-9.3,7.2-15.6,8.5c-1.7,0.4-2.6,0.4-6.2,0.4c-3.6,0-4.5-0.1-6.2-0.4
          c-4.1-0.9-7.7-2.4-11.2-4.7c-2.5-1.7-6.5-5.7-8.2-8.2C20.8,62,19,56.3,19,50s1.7-12,5.3-17.4c1.7-2.5,5.7-6.5,8.2-8.2
          c3.7-2.5,7.9-4.2,12-4.9C47.5,19.1,52,19,55,19.6z"/>
      </svg>
    </div>
    <div class="l_title">ЗАГРУЗКА</div>
  </div>
</template>

<script>
export default {
  name: 'loading',
}
</script>

<style scoped>
  .loading_wrap {
    width: 100%;
    height: auto;
  }
  .loading_wrap .l_title {
    padding: 5px 0 5px 0;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    color: #174A8B;
  }
  .loading_wrap .svg_in {
    margin: 10px auto 10px auto;
    width: 50px ;
    height: 50px;
  }
  .svg_in svg {
    fill: #174A8B;
    width: 100%;
    height: auto;
  }
  .rotateIn {
    -webkit-animation-name: rotateIn;
    animation-name: rotateIn;
    -webkit-animation-duration: 5s;
    animation-duration: 5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
  }
  @keyframes rotateIn {
    0% {
      -webkit-transform-origin: center;
      transform-origin: center;
      -webkit-transform: none;
      transform: none;
      opacity: 1;
    }
    5% {
      -webkit-transform-origin: center;
      transform-origin: center;
      -webkit-transform: none;
      transform: none;
      opacity: 1;
    }
    95% {
      -webkit-transform-origin: center;
      transform-origin: center;
      -webkit-transform: rotate3d(0, 0, 1, -360deg);
      transform: rotate3d(0, 0, 1, -360deg);
      opacity: 1;
    }
    100% {
      -webkit-transform-origin: center;
      transform-origin: center;
      -webkit-transform: none;
      transform: none;
      opacity: 0;
    }
  }
</style>

